<script setup lang="ts">
const { size = 'small' } = defineProps<{ size?: 'small' | 'medium' | 'large' }>()
</script>

<template>
  <div
    :class="{
      'dot-flashing': true,
      'dot-flashing__medium': size === 'medium',
      'dot-flashing__large': size === 'large'
    }"
  ></div>
</template>

<style scoped lang="scss">
.dot-flashing {
  position: relative;
  width: 3px;
  height: 3px;
  border-radius: 5px;
  background-color: #b5b4ba;
  color: #b5b4ba;
  animation: dot-flashing 1s infinite linear alternate;
  animation-delay: 0.5s;
  margin-bottom: 6px;

  &::before,
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    border-radius: 5px;
    background-color: #b5b4ba;
    color: #b5b4ba;
    animation: dot-flashing 1s infinite alternate;
  }

  &::before {
    left: -4px;
    width: 3px;
    height: 3px;
    animation-delay: 0s;
  }

  &::after {
    left: 4px;
    width: 3px;
    height: 3px;
    animation-delay: 1s;
  }

  &__medium {
    width: 6px;
    height: 6px;

    &::before {
      left: -9px;
      width: 6px;
      height: 6px;
    }

    &::after {
      left: 9px;
      width: 6px;
      height: 6px;
    }
  }

  &__large {
    width: 10px;
    height: 10px;

    &::before {
      left: -15px;
      width: 10px;
      height: 10px;
    }

    &::after {
      left: 15px;
      width: 10px;
      height: 10px;
    }
  }
}

@keyframes dot-flashing {
  0% {
    background-color: #b5b4ba;
  }
  50%,
  100% {
    background-color: rgba(73, 72, 75, 0.2);
  }
}
</style>
